'use client';

interface Tab {
  id: string;
  label: string;
}

interface TabSwitcherProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
}

export default function TabSwitcher({ tabs, activeTab, onTabChange }: TabSwitcherProps) {
  return (
    <div className="flex border-b-2 border-[#D4D4D4] mb-6 overflow-x-auto scrollbar-none">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-5 h-11 font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] border-b-2 -mb-0.5 transition-all duration-150 whitespace-nowrap shrink-0 ${
            activeTab === tab.id
              ? 'border-[#0D0D0D] text-[#0D0D0D]'
              : 'border-transparent text-[#6B6B6B] hover:text-[#2D2D2D]'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
